module.exports = __webpack_public_path__ + "static/media/52561523_2452972101444633_3139548555673337856_o.293cd107.jpg";